import { useEffect, useState } from 'react';
import { Palette } from 'lucide-react';

// Library motif: recolourable on textiles, or locked to one fixed colour (e.g. logos).
export const ColorRule = ({ item, disabled, save }) => {
  const free = item.recolorable !== false, [color, setColor] = useState(item.fixed_color || '#111111');
  useEffect(() => setColor(item.fixed_color || '#111111'), [item.fixed_color]);
  return <span className="library-color-rule" data-testid={`library-color-rule-${item.id}`}>
    <label title="Kunden dürfen die Farbe auf Textilien ändern"><input type="checkbox" checked={free} disabled={disabled} onChange={e => save({ recolorable: e.target.checked, fixed_color: color })} data-testid={`library-recolorable-${item.id}`} /><Palette size={14} />{free ? 'Umfärbbar' : 'Feste Farbe'}</label>
    {!free && <input type="color" value={color} disabled={disabled} onChange={e => setColor(e.target.value)} onBlur={() => color !== item.fixed_color && save({ recolorable: false, fixed_color: color })} title="Feste Farbe" data-testid={`library-fixed-color-${item.id}`} />}
  </span>;
};
